import React, { memo } from 'react';

import IconLabel from '@fmbt/ui/IconLabel';

import './BlankState.less';

type BlankStateIconComponent = React.ComponentType<{ size: number }>;

type BlankStateProps = {
  /** Rendered as `<Icon size={60} />`. */
  Icon: BlankStateIconComponent;
  title: string;
  /** Rendered as secondary text. */
  subTitle?: string | JSX.Element;
};

/** @see https://www.figma.com/design/Vvl7WmeGXXmS948pRsQNKE/Farmbot-Outback-Design-System?node-id=2267-3211 */
function BlankState({ Icon, title, subTitle }: BlankStateProps): JSX.Element {
  const label = subTitle
    ? (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div className="BlankState-title">{title}</div>
        <div className="BlankState-subtitle">{subTitle}</div>
      </div>
    )
    : <div className="BlankState-title">{title}</div>;
  return (
    <IconLabel
      direction="vertical"
      gap={12}
      icon={<Icon size={60} />}
      label={label}
    />
  );
}

export default memo(BlankState);
export type { BlankStateIconComponent, BlankStateProps };
